module.exports = __webpack_public_path__ + "img/cj-draw-bilibili.2dd8d0e5.png";